document.addEventListener("DOMContentLoaded", function() {
  const swatchContainer = document.querySelector('.product-form-wrapper');
  console.log('class ketemu :', swatchContainer);
  if (!swatchContainer) return; // kalau ga ada, stop di sini

  swatchContainer.querySelectorAll('label').forEach(label => {
    const sizeLabel = label.querySelector('.swatch-size-label[data-length="3"]');
    const sizeValue = label.querySelector('.swatch-size-value');

    if (sizeLabel && sizeValue) {
      const labelText = sizeLabel.textContent.trim();
      const valueText = sizeValue.textContent.trim();

      // cek apakah label sudah benar formatnya (contoh: "US W" dan bawahnya angka)
      const isAlreadyCorrect =
        /^[A-Z]{2,3}\s[A-Z]$/.test(labelText) && /^\d/.test(valueText);

      if (isAlreadyCorrect) {
        // sudah benar → skip aja
        console.log(`✅ Sudah benar: ${labelText} / ${valueText}`);
        return;
      }

      // kalau belum benar → cek format lama (misal: "US 7" di atas dan "M" di bawah)
      const textParts = labelText.split(' ');
      if (textParts.length === 2) {
        const top = `${textParts[0]} ${valueText}`;
        const bottom = textParts[1];

        sizeLabel.textContent = top;
        sizeValue.textContent = bottom;

        console.log(`🔄 Diubah jadi: ${top} / ${bottom}`);
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // ✅ Hanya aktif di mobile
  if (window.innerWidth <= 768) {
    const searchButton = document.querySelector('.search-button-container');
    const filterPanel = document.querySelector('.CollectionInner__Filter.collection-sidebar-panel');
    const cancelFilterBtn = document.querySelector('.cancel-filter');

    if (searchButton && filterPanel && cancelFilterBtn) {
      searchButton.addEventListener('click', function () {
        // Kalau filter lagi aktif
        if (filterPanel.classList.contains('active')) {
          // Simulasi klik tombol cancel filter
          cancelFilterBtn.click();
        }
      });
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {
  // ✅ Hanya aktif di mobile
  if (window.innerWidth <= 768) {
    const okayBtn = document.querySelector('.button-after-submit button');

    if (okayBtn) {
      okayBtn.addEventListener('click', function (e) {
        e.preventDefault();
        location.reload(); // langsung refresh halaman
      });
    }
  }
});

document.querySelector('.menu-shop-by').addEventListener('mouseenter', function() {
    document.body.style.overflow = 'auto'; // biar scroll halaman tetap ada
});


// handle spesial release
document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".collection-features-item");

  items.forEach(item => {
    if (item.dataset.handle !== "special_releases") {
      item.style.display = "none";
    }
  });
});
